export const BOGGLE_GRID_SIZE = '4x4'
export const BOGGLE_MIN_WORD_LENGTH = 3
export const BOGGLE_ALLOW_DIAGONALS = true
export const BOGGLE_REPEAT_TILE_MIN_GAP = 1
export const BOGGLE_MIN_VOWEL_RATIO = 0.3
/** Matches refill policy upper bound (exclusive) for UI blending only. */
export const BOGGLE_MAX_VOWEL_RATIO_EXCLUSIVE = 0.5
export const BOGGLE_SCORE_MODE = 'per-cleared-tile'
export const BOGGLE_SCORE_BONUS_MAX_LENGTH = null
export const EXTRA_LETTER_BONUS_TIME = 1
export const BOGGLE_DEFAULT_SEED = 20260405
export const BOGGLE_RESOLVE_ANIMATION_MS = 150
/** Spawned letters begin their descent this many fractional grid rows above the destination. */
export const BOGGLE_SPAWN_START_ROWS_ABOVE = 0.3
export const BOGGLE_ROTATE_ANIMATION_MS = 180
export const BOGGLE_ROTATE_GRAVITY_ANIMATION_MS = 180
export const BOGGLE_INVALID_FEEDBACK_MS = 900
export const BOGGLE_INTERVAL_PREP_COUNT = 3
export const BOGGLE_INTERVAL_PREP_STEP_MS = 700
/** Wall-clock duration before the interval timer starts (3-2-1 countdown). */
export const BOGGLE_INTERVAL_PREP_MS =
  BOGGLE_INTERVAL_PREP_COUNT * BOGGLE_INTERVAL_PREP_STEP_MS
export const BOGGLE_INITIAL_COPIES = null
export const BOGGLE_INITIAL_RESETS = null
export const BOGGLE_INITIAL_SHUFFLES = null
export const BOGGLE_INITIAL_ZAPS = null
export const BOGGLE_INITIAL_SWAPS = null
